<div *ngIf="showReportLoadingBanner" [@dropDown] class="pointer-events-none fixed inset-x-0 top-0 sm:flex sm:justify-center sm:px-6 sm:pt-5 lg:px-8 z-40">
  <div class="pointer-events-auto flex items-center justify-between gap-x-6 bg-secondary moving-gradient shadow-secondary/25 px-6 py-2.5 sm:rounded-xl shadow-lg sm:py-3 sm:pl-4 sm:pr-3.5">

    <div class="flex items-center w-[20rem]">
      <span class="small-loader mr-3"></span>
      <p class="text-sm text-primary-100 leading-6">
        {{ reportMessage }}
      </p>
    </div>

    <button type="button" (click)="closeReportLoadingBanner()" class="-m-1.5 flex-none p-1.5">
      <span class="sr-only">Dismiss</span>
      <svg class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
      </svg>
    </button>

  </div>
</div>

<div *ngIf="showReportGeneratedBanner" [@dropDown] class="pointer-events-none fixed inset-x-0 top-0 sm:flex sm:justify-center sm:px-6 sm:pt-5 lg:px-8 z-20">
  <div class="pointer-events-auto flex items-center justify-between gap-x-6 bg-secondary moving-gradient shadow-secondary/25 px-6 py-2.5 sm:rounded-xl shadow-lg sm:py-3 sm:pl-4 sm:pr-3.5">
    <div>
      <p class="text-sm text-primary-100 leading-6">
        <span *ngIf="!isBulkUpload">
          Report of <span class="text-primary-100 font-semibold">{{ reportName }}</span> has been successfully generated.
        </span>
        <span *ngIf="isBulkUpload">
          Reports have been successfully generated for all contacts.
        </span>
      </p>
    </div>

    <!--
    <button type="button" (click)="viewReport()" class="text-sm font-semibold text-primary-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-transparent">View Report</button>
    -->

    <button type="button" (click)="closeReportGeneratedBanner()" class="-m-1.5 flex-none p-1.5">
      <span class="sr-only">Dismiss</span>
      <svg class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
      </svg>
    </button>

  </div>
</div>

<div *ngIf="showReportNotGeneratedGeneratedBanner" [@dropDown] class="pointer-events-none fixed inset-x-0 top-0 sm:flex sm:justify-center sm:px-6 sm:pt-5 lg:px-8 z-20">
  <div class="pointer-events-auto flex items-center justify-between gap-x-6 bg-red-500 px-6 py-2.5 sm:rounded-xl shadow-lg sm:py-3 sm:pl-4 sm:pr-3.5">

    <div class="flex items-center w-[20rem]">
      <p class="text-sm text-primary-100 leading-6">
        <span *ngIf="!isBulkUpload">Report could not be generated.</span>
        <span *ngIf="isBulkUpload">Some reports could not be generated.</span>
      </p>
    </div>

    <button type="button" (click)="closeReportGeneratedBanner()" class="-m-1.5 flex-none p-1.5">
      <span class="sr-only">Dismiss</span>
      <svg class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
      </svg>
    </button>

  </div>
</div>

<div *ngIf="changeCompany.showBanner" [@dropDown] class="pointer-events-none fixed inset-x-0 top-0 sm:flex sm:justify-center sm:px-6 sm:pt-5 lg:px-8 z-20">
  <div class="pointer-events-auto flex items-center justify-between gap-x-6 bg-secondary moving-gradient shadow-secondary/25 px-6 py-2.5 sm:rounded-xl shadow-lg sm:py-3 sm:pl-4 sm:pr-3.5">

    <div class="flex items-center w-[20rem]">
      <span *ngIf="changeCompany.showLoading" class="small-loader mr-3"></span>
      <p class="text-sm text-primary-100 leading-6">
        {{ changeCompany.message }}
      </p>
    </div>

    <button type="button" (click)="closeChangeCompanyBanner()" class="-m-1.5 flex-none p-1.5">
      <span class="sr-only">Dismiss</span>
      <svg class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
      </svg>
    </button>

  </div>
</div>
